import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "body",
  class: "fullwidth"
}
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "width-wrap" }
const _hoisted_4 = { class: "page-content" }
const _hoisted_5 = { class: "width-wrap" }
const _hoisted_6 = { class: "search-list" }
const _hoisted_7 = { class: "search-list__item-body" }
const _hoisted_8 = { class: "search-list__item-title" }
const _hoisted_9 = { class: "search-list__item-text" }
const _hoisted_10 = { class: "search-list__item-footer" }
const _hoisted_11 = { class: "buttons-inline" }
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('AdFilterList.title')) + ": " + _toDisplayString(_ctx.pagedList.totalCount), 1),
        _createElementVNode("div", null, _toDisplayString(_ctx.$t('AdFilterList.subtitle')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagedList.data, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "search-list__item",
              key: item.adFilterId
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('AdFilterList.item-title')) + ": " + _toDisplayString(item.title), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('AdFilterList.item-frequency')) + ": ", 1),
                    _createElementVNode("span", null, _toDisplayString(item.frequencyTitle), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('AdFilterList.item-lastChanged')) + ": ", 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$filters.date(item.lastChanged, 'dd.MM.yyyy HH:mm')), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_router_link, {
                  tag: "button",
                  to: { name: 'AdSearch', query: { adFilterId: item.adFilterId } },
                  class: "button button--primary reversed",
                  type: "button"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('AdFilterList.button-show')), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", {
                    class: "button button--danger",
                    type: "button",
                    onClick: ($event: any) => (_ctx.remove(item.adFilterId))
                  }, _toDisplayString(_ctx.$t('AdFilterList.button-delete')), 9, _hoisted_12),
                  _createVNode(_component_router_link, {
                    tag: "button",
                    to: { name: 'AdSearch', query: { adFilterId: item.adFilterId } },
                    class: "button button--primary",
                    type: "button"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('AdFilterList.button-edit')), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}